export default {
  '1': 10,
  '7': 10,
  '20': 10,
  '27': 9,
  '30': 10,
  '31': 9,
  '32': 9,
  '33': 9,
  '34': 9,
  '36': 9,
  '39': 10,
  '40': 10,
  '41': 9,
  '43': [10, 11],
  '44': 10,
  '45': 8,
  '46': 7,
  '47': 8,
  '48': 9,
  '49': [10, 11],
  '51': 9,
  '52': 10,
  '53': 8,
  '54': [6, 7, 8],
  '55': 11,
  '56': 9,
  '57': 10,
  '58': 7,
  '60': [7, 9, 10, 11],
  '61': 9,
  '62': 11,
  '63': 10,
  '64': [8, 9],
  '65': 8,
  '66': 9,
  '81': 10,
  '82': [7, 8],
  '84': 9,
  '86': 11,
  '90': [7, 8, 9, 10, 11],
  '91': 10,
  '92': 10,
  '93': 9,
  '94': 7,
  '95': [7, 8, 9, 10],
  '98': 11,
  '211': 7,
  '212': 9,
  '213': 9,
  '216': 8,
  '218': 10,
  '220': 7,
  '221': 9,
  '222': 8,
  '223': 8,
  '224': 9,
  '225': 8,
  '226': 8,
  '227': 8,
  '228': 8,
  '229': 8,
  '230': 8,
  '231': [8, 9],
  '232': 8,
  '233': 9,
  '234': 8,
  '235': 6,
  '236': 8,
  '237': 9,
  '238': 7,
  '239': 7,
  '240': 9,
  '241': 7,
  '242': 9,
  '243': 7,
  '244': 9,
  '245': 9,
  '246': 7,
  '248': 7,
  '249': 7,
  '250': 9,
  '251': 9,
  '252': [8, 9],
  '253': 10,
  '254': 10,
  '255': [7,9],
  '256': [6, 7, 8, 9, 10],
  '257': 8,
  '258': 12,
  '260': 9,
  '261': 7,
  '262': 9,
  '263': 9,
  '264': 7,
  '265': [7, 8, 9],
  '266': 8,
  '267': 7,
  '268': 8,
  '269': 7,
  '290': 4,
  '291': 7,
  '297': 7,
  '298': 5,
  '299': 6,
  '350': 8,
  '351': 9,
  '352': 9,
  '353': 9,
  '354': 7,
  '355': 9,
  '356': 8,
  '357': 8,
  '358': [7, 8, 9, 10],
  '359': 9,
  '370': 8,
  '371': 8,
  '372': 8,
  '373': 8,
  '374': [6, 8],
  '375': 9,
  '376': 6,
  '377': 8,
  '378': 10,
  '379': 10,
  '380': 9,
  '381': 9,
  '382': 8,
  '383': 8,
  '385': 9,
  '386': 9,
  '387': 8,
  '389': 8,
  '420': 9,
  '421': 9,
  '423': 7,
  '500': 5,
  '501': 7,
  '502': 8,
  '503': 8,
  '504': 8,
  '505': 8,
  '506': 8,
  '507': 8,
  '508': 6,
  '509': 8,
  '590': 6,
  '591': 9,
  '592': 7,
  '593': 9,
  '594': 9,
  '595': 9,
  '596': 9,
  '597': [6, 7],
  '598': 8,
  '599': 7,
  '670': 7,
  '672': 6,
  '673': 7,
  '674': 7,
  '675': 8,
  '676': 5,
  '677': 7,
  '678': 5,
  '679': 7,
  '680': 7,
  '681': 6,
  '682': 5,
  '683': 4,
  '685': [5, 6, 7],
  '686': 8,
  '687': 6,
  '688': 5,
  '689': 8,
  '690': 5,
  '691': 7,
  '692': 7,
  '850': [4, 6, 7, 13],
  '852': 8,
  '853': 8,
  '855': 9,
  '856': [8, 9],
  '870': 9,
  '880': 10,
  '886': 9,
  '960': 7,
  '961': [7, 8],
  '962': [8, 9],
  '963': 7,
  '964': 10,
  '965': 8,
  '966': 9,
  '967': 9,
  '968': 8,
  '970': 9,
  '971': 9,
  '972': 9,
  '973': 8,
  '974': 8,
  '975': 7,
  '976': 8,
  '977': 10,
  '992': 9,
  '993': 8,
  '994': 9,
  '995': 9,
  '996': 9,
  '998': 9,
  '1-268': 10,
  '1-264': 10,
  '1-684': 10,
  '1-246': 10,
  '1-441': 10,
  '1-242': 10,
  '1-767': 10,
  '1-809': 10,
  '1-473': 10,
  '1-671': 10,
  '1-876': 10,
  '1-869': 10,
  '1-345': 7,
  '1-758': 7,
  '1-670': 7,
  '1-664': 10,
  '1-721': 10,
  '1-649': 10,
  '1-868': 7,
  '1-784': 7,
  '1-284': 7,
  '1-340': 10,
};
